import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Loads protected images with the Authorization header (no token in URL) and renders a blob URL.
export const AuthImage = ({ src, alt = "", className = "", ...rest }) => {
  const [url, setUrl] = useState("");
  useEffect(() => {
    if (!src) { setUrl(""); return undefined; }
    let objectUrl = "";
    let cancelled = false;
    api.get(src.replace(/^\/api/, ""), { responseType: "blob" })
      .then((r) => { if (!cancelled) { objectUrl = URL.createObjectURL(r.data); setUrl(objectUrl); } })
      .catch(() => { if (!cancelled) setUrl(""); });
    return () => { cancelled = true; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [src]);
  if (!url) return null;
  return <img src={url} alt={alt} className={className} {...rest} />;
};
